import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLHAMMER', label: 'Hammer', lookback: 11 })
